const DICTIONARY = {
    'AFAGH': 'آفاق',
    'MOHAYMEN': 'مهیمن',
    'ROHAM': 'رهام',
    'ARKA': 'آرکا',
    'PENDING': "در انتظار تایید",
    'REJECTED': "مردود",
    'APPROVED': "تایید‌ شده",
    'COMPLETED': "کامل شده"
}

export default DICTIONARY;
